export default __webpack_public_path__ + "static/img1-26eb22e033b19d6ca746ab9f6809ccb9.png";